import React, { useEffect } from "react";
import ContactLandingPage from "./ContactLandingPage";
import Footer from "../Footer/Footer";


const ContactUs = () => {
  useEffect(() => {
    document.documentElement.classList.add("contact-scrollbar-hidden");
    document.body.classList.add("contact-scrollbar-hidden");

    return () => {
      document.documentElement.classList.remove("contact-scrollbar-hidden");
      document.body.classList.remove("contact-scrollbar-hidden");
    };
  }, []);

  return (
    <div
      className="min-h-screen overflow-x-hidden bg-[#000000]"
    
    >
      <ContactLandingPage />
      <Footer />
    </div>
  );
};

export default ContactUs;
